export const ROLES = {
  admin: 3,
  employee: 1,
  organizer: 2,
  public: 0,
  'super-administrator': 4,
} as Record<string, number>

export function hasRequiredRole(userRole: string, requiredRole: string) {
  return ROLES[userRole] >= ROLES[requiredRole]
}
